module.exports = __webpack_public_path__ + "static/media/onboarding-01.2f90dab8.png";